module.exports = __webpack_public_path__ + "img/zanwushuju.6653e449.png";